module.exports = {"530925101":"勐勐镇","530925102":"勐库镇","530925201":"沙河乡","530925202":"大文乡","530925203":"忙糯乡","530925205":"邦丙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530925.json
// module id = 2420
// module chunks = 0